import { isLocalhostHostname, isTestHostname } from "Utils/hostnameUtils";
import Cookies from "js-cookie";
import React from "react";
import { config } from "../../../config";
import { FEATURE_BRANCH_COOKIE_NAME, TestBanner } from "./FeatureBranchInfo";
import { DevelopmentBanner } from "./styled";

type Environment = "test" | "development" | "production";

const getEnvironment = (): Environment => {
  if (isTestHostname()) {
    return "test";
  }
  if (isLocalhostHostname()) {
    return "development";
  }
  return "production";
};

export const EnvironmentInfo = (): React.ReactElement | null => {
  const environment = getEnvironment();
  const featuresCookie = Cookies.get(FEATURE_BRANCH_COOKIE_NAME);

  if (environment === "production") {
    return null;
  }

  if (environment === "development") {
    return <DevelopmentBanner>DEVELOPMENT</DevelopmentBanner>;
  }
  return <TestBanner appName={config.name} featuresCookie={featuresCookie} />;
};
